import { render } from "./International.vue?vue&type=template&id=61774446&ts=true"
import script from "./International.vue?vue&type=script&lang=ts"
export * from "./International.vue?vue&type=script&lang=ts"

import "./International.vue?vue&type=style&index=0&id=61774446&lang=scss"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__